export const csvObj = (csv, delimiter = ',') => {
  const lines = csv.split('\n')
  let result = []
  // ignore 1st line as it is header
  for (let i = 1; i < lines.length; i++) {
    const objArray = lines[i].split(delimiter)
    if (objArray && objArray.length > 0 && objArray[0] !== '') {
      result.push(lines[i].split(delimiter))
    }
  }
  return result
}

export function downloadPrompt(content, filename) {
  // REF: https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(content, filename)
  } else {
    var tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    var blobURL = window.URL.createObjectURL(content)
    tempLink.href = blobURL
    tempLink.setAttribute('download', filename)

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }

    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobURL)
  }
}
